import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class SurveyAnswer extends BaseModel {
    @Expose() question = "";
    @Expose() comment? = "";
    @Expose() answer = "";
}
